import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { useHRPayrollGate } from '@/hooks/useHRPayrollEnabled'

// Route-level gate for Staff & Payroll (F-HR-N1): nothing mounts unless this
// tenant has FEATURE_HR_PAYROLL=1.
export function HRPayrollGate({ children }: { children: ReactNode }) {
  const gate = useHRPayrollGate()
  if (gate.enabled) return <>{children}</>
  if (gate.isLoading) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>
  if (gate.isError)
    return (
      <div className="flex flex-col items-center gap-3 p-8 text-center">
        <p className="text-sm text-muted-foreground">Couldn’t load settings. Check your connection and try again.</p>
        <Button variant="outline" onClick={gate.retry}>
          Retry
        </Button>
      </div>
    )
  return <div className="p-8 text-center text-sm text-muted-foreground">Staff &amp; Payroll isn’t switched on for this restaurant.</div>
}
